import React from 'react'
import DownloadCSV, { fileNameWithDate } from '../../../io/download-csv'
import DownloadButton from '../../../ui/download-button'


const apiPath = (record) => (
  `${process.env.REACT_APP_API_HOST}/api/${record.type}s/${record.type_id}/advances`
)

export const ExportAdvances = ({ remote_request, record }) => {
  const {
    loading, errors
  } = remote_request.state

  return (
    <DownloadButton
      loading={loading}
      errors={errors}
      onClick={() => remote_request.submit({
        url: apiPath(record),
        method: 'GET',
        fileName: fileNameWithDate(`${record.name} advances`)
      })}
    >
      Enrolment Advances
    </DownloadButton>
  )
}

export default DownloadCSV(ExportAdvances)



// WEBPACK FOOTER //
// ./src/gov-registrations/details/export-advances/index.js